import { api } from '@api'
import { Equipment } from '@types'

interface GetEquipmentResponse {
  equipment: Equipment[]
}

const getEquipment = async () => {
  const response = await api.get<GetEquipmentResponse>('/equipments')

  return response.data.equipment
}

export { getEquipment }
